<template>
    <div class="AddCardModal">
        <h1>Add Credit Card</h1>
        <div class="main">
            <CardForm ref="cardForm"
                :firstName.sync="firstName"
                :lastName.sync="lastName"
                :address.sync="address"
                :city.sync="city"
                :state.sync="state"
                :zip.sync="zip"
            />
        </div>

        <div class="actions">
            <Button class="link" @click="handleCancel">Cancel</Button>
            <Button class="primary" @click="handleConfirm" :disabled="submitStatus === 'PENDING'">Add</Button>
        </div>
    </div>
</template>

<script>
import * as api from '@/api';
import CardForm from '@/components/form/CardForm';

export default {
    name: 'AddCardModal',

    components: { CardForm },

    data: () => ({
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        state: '',
        zip: '',

        submitStatus: '',
    }),

    methods: {
        async handleConfirm() {
            if (!this.$refs.cardForm.validate()) {
                return;
            }

            this.submitStatus = 'PENDING';
            const stripeRes = await this.$stripe.createPaymentMethod({
                type: 'card',
                card: this.$refs.cardForm.card,
                billing_details: {
                    name: `${this.firstName} ${this.lastName}`.trim(),
                    email: this.$store.state.auth.user.email,
                    address: {
                        country: 'US',
                        state: this.state,
                        city: this.city,
                        line1: this.address,
                        postal_code: this.zip,
                    },
                },
            });

            if (stripeRes.error) {
                this.submitStatus = 'ERROR';
                return this.$awn.alert(stripeRes.error.message);
            }

            const res = await api.createPaymentMethod(stripeRes.paymentMethod.id);
            if (!res.ok) {
                this.submitStatus = 'ERROR';
                return this.$awn.alert('Failed to update card information');
            }

            this.submitStatus = 'OK';
            this.$awn.success('Card updated!');
            this.$emit('close');
        },

        handleCancel() {
            this.$emit('close');
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.AddCardModal {
    @extend %modal;

    .actions {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
